function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  viewBox: "0 0 73 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "2",
  d: "M71 35.6875H-1.13249e-06"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "2",
  d: "M43.9063 0.648435L70.8594 35.6874L43.9063 70.7264"
}));